import { useState, useEffect } from 'react';
/* datas */
import { HostBackend } from '../../../Routes/HostBackend.js';
import { GetHeaders } from '../../../Components/Admin/Functions/FetchHeaders.js';
import { GetUpperCase } from '../../../Components/Public/Functions/GetUpperCase.js';
import { GetYearMonthDay } from '../../Public/Functions/GetDates.js';

export const FinderAdmin = (prop) => {
    const { table } = prop;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [show, setShow] = useState(0);
    const [showSub, setShowSub] = useState(0);
    const [find, setFind] = useState('');
    const [datas, setDatas] = useState([]);
    useEffect(() => {
        if (find.length > 1) {
            const fetchDatas = async () => {
                const datasFind = await fetch(`${backend}/admin/find?table=${table}&find=${find}`, GetHeaders(token));
                const datas = await datasFind.json();
                setDatas(datas);
            };
            fetchDatas();
        }
    }, [backend, table, find, token]);
    let name, href;
    if (datas.length > 0) {
        return (
            <div className="finder">
                <div className="label" onClick={(e) => { show === 0 ? setShow(1) : setShow(0); setShowSub(0); }}>
                    <div>{GetUpperCase(table)}</div>
                    <i className="fa fa-search"></i>
                </div>
                <div className={`search ${show === 1 ? 'show' : 'hide'}`}>
                    <input type="text" max="50" value={find} name="find" onChange={(e) => { setFind(e.target.value); setShowSub(1); }} />
                    <div className={`datas ${showSub === 1 ? 'show' : 'hide'}`}>
                        {datas.map((el, i) => {
                            if (table === 'administrator') {
                                name = el.lastname;
                            } else if (table === 'user') {
                                name = el.lastname;
                            } else if (table === 'history') {
                                name = GetYearMonthDay(el.created);
                            } else {
                                name = el.name;
                            }
                            href = `/admin/entity/update/${table}/${el.id}`;
                            return (
                                <a className="link" href={href} key={i}>{name}</a>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="finder">
                <div className="label" onClick={(e) => { show === 0 ? setShow(1) : setShow(0); setShowSub(0); }}>
                    <div>{GetUpperCase(table)}</div>
                    <i className="fa fa-search"></i>
                </div>
                <div className={`search ${show === 1 ? 'show' : 'hide'}`}>
                    <input type="text" max="50" value={find} name="find" onChange={(e) => { setFind(e.target.value); setShowSub(1); }} />
                    <div className={`datas ${showSub === 1 ? 'show' : 'hide'}`}>
                        {datas.msg}
                    </div>
                </div>
            </div>
        )

    }
}